<template>
    <div>
        <b-navbar toggleable="lg" type="dark" class="transparent">
            <b-navbar-brand @click.prevent="back">
                <span><i class="fas fa-arrow-left"></i></span>
            </b-navbar-brand>
        </b-navbar>

        <div v-if="pageLoad">
            <div class="header"
                 v-bind:style="{ backgroundImage: 'linear-gradient(to top, rgba(0,0,0, .7), rgba(0,0,0, .7)), url('+[rates.place.detail ? rates.place.detail : 'linear-gradient(to top, #18336a, #654DB9)']+ ')'}">
            </div>

            <div class="place-content" v-if="rates.place.id">
                <div>
                    <span class="title">{{ rates.place.name }}</span>
                </div>
                <div>
                    <span class="address">{{ rates.place.address }}</span>
                </div>
                <div class="air-votes global" v-if="connected">
                    <div class="short-info">
                        <b>{{rates.place.rates_info.rate1+rates.place.rates_info.rate2+rates.place.rates_info.rate3}} </b>
                        <b v-text="translate('AirVotes')">Air Votes</b>
                    </div>
                    <div class="detailed-info">
                        <ul class="rates">
                            <li>
                                <div class="image cool">
                                    <img src="../assets/icons/smile-simple.svg" alt="">
                                </div>
                                {{rates.place.rates_info.rate3}}
                            </li>
                            <li>
                                <div class="image soso">
                                    <img src="../assets/icons/normal-simple.svg" alt="">
                                </div>
                                {{rates.place.rates_info.rate2}}
                            </li>
                            <li>
                                <div class="image meh">
                                    <img src="../assets/icons/sad-simple.svg" alt="">
                                </div>
                                {{rates.place.rates_info.rate1}}
                            </li>
                        </ul>
                    </div>
                </div>

                <div v-if="!connected" class="air-votes-empty">
                    {{ translate('NotConnectedPlaceToAirVote') }}
                </div>

                <div class="air-votes personal" v-if="connected">
                    <div class="short-info">
                        <b>{{rates.rates.length}} </b>
                        <b v-text="translate('YourVotes')"></b>
                    </div>
                    <div class="schedule">
                        <ul>
                            <li v-for="item in rates.rates" v-bind:key="item.id">
                                <div class="date">
                                    <span>{{item.date | moment("D MMM YYYY ")}} </span>
                                </div>
                                <div class="ico">
                                    <div class="image cool">
                                        <img v-if="item.rate == 3" alt="logo" src="../assets/icons/smile-simple.svg">
                                    </div>
                                    <div class="image soso">
                                        <img v-if="item.rate == 2" alt="logo" src="../assets/icons/normal-simple.svg">
                                    </div>
                                    <div class="image meh">
                                        <img v-if="item.rate == 1" alt="logo" src="../assets/icons/sad-simple.svg">
                                    </div>
                                </div>
                                <div class="change">
                                    <button @click="changeRateModal(item)" v-text="translate('Change')"></button>
                                </div>
                            </li>
                        </ul>

                    </div>
                </div>

                <div class="change-rate" v-bind:style="{ display: [showModal ? 'flex' : 'none']}">
                    <div class="change-rate-close" @click="showModal=false"></div>
                    <div class="change-rate-body">
                        <div class="push_rate">
                            <h6 v-text="translate('ChangedYourMind')"></h6>
                            <ul>
                                <li v-bind:class="'cool ' + [changeRateIndex == '3' ? 'active' : '']">
                                    <a @click="changeRateIndex = 3">
                                        <img alt="logo" src="../assets/re/smile/cool.png">
                                    </a>
                                </li>
                                <li v-bind:class="'soso ' + [changeRateIndex == '2' ? 'active' : '']">
                                    <a @click="changeRateIndex = 2">
                                        <img alt="logo" src="../assets/re/smile/soso.png">
                                    </a>
                                </li>
                                <li v-bind:class="'meh ' + [changeRateIndex == '1' ? 'active' : '']">
                                    <a @click="changeRateIndex = 1">
                                        <img alt="logo" src="../assets/re/smile/meh.png">
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="submit">
                            <b-button block @click="changeRate(changeRateIndex)">
                                <span v-text="translate('Submit')">Submit</span>
                                <img src="../assets/re/Triangle.svg">
                            </b-button>
                        </div>
                        <div class="cancel">
                            <button @click="showModal=false" v-text="translate('Cancel')">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="page-spinner">
            <b-spinner v-if="!pageLoad" style="width: 3rem; height: 3rem;" type="grow" label="Spinning"></b-spinner>
        </div>

    </div>


</template>

<script>
    import errorMixin from '@/mixins/errorMixin';
    import {mapActions} from 'vuex';

    export default {
        mixins: [mixin, errorMixin],
        data() {
            return {
                name: 'list',
                pageLoad: false,
                showModal: false,
                connected: true,
                changeRateID: undefined,
                changeRateIndex: undefined,
                rates: {
                    place: {
                        address: '',
                        id: '',
                        location: {
                            lat: 0,
                            lng: 0
                        },
                        name: '',
                        photo_url: '',
                        rates_info: {
                            rate1: 0,
                            rate2: 0,
                            rate3: 0
                        },
                        unique_users_rated: 0
                    },
                    rates: [{}]
                },
                place_id: this.$route.params.id
            }
        },
        mounted() {
            if (localStorage.getItem('access_token') == undefined) {
                this.$router.push('/sign-in');
                return false;
            } else {
                this.getInfo();
            }

            const header = document.querySelector('.navbar')
            window.addEventListener('scroll', function () {
                if (pageYOffset >= 200) {
                    header.classList.add('waypoint-bg')
                } else {
                    header.classList.remove('waypoint-bg')
                }
            });
        },
        methods: {
            ...mapActions({
                getDetailPlace: 'place/getDetailPlace',
                changeRateAction: 'rate/changeRate'
            }),

            async getInfo() {
                const response = await this.getDetailPlace(this.place_id)
                if (response.data.success) {
                    this.rates = response.data;
                    if (response.data.place.organization_id == null &&
                        ((response.data.place.rates_info.rate1 +
                            response.data.place.rates_info.rate2 +
                            response.data.place.rates_info.rate3) == 0)) {
                        this.connected = false;
                    }
                    this.pageLoad = true;
                } else {
                    this.showErrorModal()
                }
            },

            changeRateModal(item) {
                this.showModal = true;
                this.changeRateID = item.itemId;
                this.changeRateIndex = item.rate;
            },

            async changeRate(rate) {
                const response = await this.changeRateAction({
                    changeRateID: this.changeRateID,
                    rate
                })
                if (response.data.success) {
                    await this.getInfo()
                    this.showModal = false
                } else {
                    this.showErrorModal()
                }
            }
        },

    }
</script>

<style>
    nav.navbar.transparent {
        /* background: linear-gradient(to top, rgba(5,42,114,0), #052A72)!important; */
        background: none !important;
        position: fixed;
        width: 100%;
        z-index: 9;
    }

    .bg-info {
        background: transparent;
    }
</style>
<style scoped>
    .push_rate ul li.active.cool {
        box-shadow: inset 0 0 0 0.35em #209400
    }

    .push_rate ul li.active.soso {
        box-shadow: inset 0 0 0 0.35em #ffc800
    }

    .push_rate ul li.active.meh {
        box-shadow: inset 0 0 0 0.35em #e01300
    }

    .push_rate ul li a {
        padding-top: 10px;
        width: 28vw;
        height: 28vw;
        max-width: 100px;
        max-height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .push_rate ul li {
        margin: 0;
    }

    .push_rate ul {
        display: flex;
        justify-content: space-between;
        margin: 1.5em 0;
    }

    .change-rate h6 {
        font-weight: 700;
    }

    .change-rate {
        width: 100%;
        position: fixed;
        bottom: 0;
        z-index: 99;
        left: 0;

    }

    .cancel button {
        background: none;
        border: 0;
        color: #2F2F2F;
        margin-top: 1em;
        font-size: 0.9em;
    }

    .submit button img {
        margin-left: 0.5em;
        width: 0.6em;
    }

    .submit button {
        padding: 0.7em 0;
        background: #2F2F2F;
    }

    .submit {
        width: 100%;
    }

    .change-rate-close {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, .5);
        z-index: 9;
    }

    .change-rate-body {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background: #fff;
        padding: 1.5em 1em 1em;
        -webkit-border-radius: 1em 1em 0em 0em;
        -moz-border-radius: 1em 1em 0em 0em;
        border-radius: 1em 1em 0em 0em;
        position: relative;
        z-index: 99;
        width: 100%;
    }

    /**/
    .place-content {
        padding: 1em;
    }

    .place-content span.title {
        font-weight: 700;
        font-size: 1.3em;
    }

    .place-content span.address {
        font-size: 0.8em;
        margin-bottom: 2em;
        display: block;
    }

    .short-info {
        font-weight: 700;
        margin-bottom: .3em;
        font-size: .8em;
    }

    .detailed-info ul {
        display: flex;
        justify-content: space-between;
    }

    .detailed-info ul li {
        margin: 0;
        width: 30%;
        max-width: 150px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #F3F3F3;
        padding: .5em 0;
        -webkit-border-radius: 0.4em;
        -moz-border-radius: 0.4em;
        border-radius: 0.4em;
        font-weight: 700;

    }

    .detailed-info ul li .image {
        width: 1.5em;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        margin-right: 0.3em;
    }

    .detailed-info ul li .image.cool {
        background-color: #36BC00
    }

    .detailed-info ul li .image.soso {
        background-color: #FFB000
    }

    .detailed-info ul li .image.meh {
        background-color: #EF4300
    }

    .detailed-info ul li .image img {
        width: 100%;
        transform: scale(1.4) translateY(1px);
    }

    .schedule ul {
        display: flex;
        flex-direction: column;
        width: 100%;
    }

    .schedule li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0;
        background: #F3F3F3;
        -webkit-border-radius: .3em;
        -moz-border-radius: .3em;
        border-radius: .3em;
        margin-bottom: 1em;
        padding: 0 0.4em;
    }

    .schedule li .date {
        font-size: 0.8em;
        text-align: center;
    }

    .schedule li .ico {
        width: 40%;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        text-align: center;
        align-items: center;
        justify-content: center;
    }

    .schedule li .change {
        text-align: right;
    }

    .schedule li .change button {
        border: 0;
        background: 0;
        color: #1976D2;
        font-size: .8em;
    }


    .ico .image {
        width: 2em;
        -webkit-border-radius: 50%;
        -moz-border-radius: 50%;
        border-radius: 50%;
        margin-right: 0;
        transform: scale(1.3);
        transition: all .3s ease-in-out;
    }

    .ico .image.cool {
        background-color: #36BC00;
    }

    .ico .image.soso {
        background-color: #FFB000;

    }

    .ico .image.meh {
        background-color: #EF4300;
    }

    .ico .image img {
        width: 100%;
        transform: scale(1.4) translateY(5%);
    }

    .air-votes-empty {
        text-align: center;
        font-weight: 700;
    }
</style>
